function decodeHTMLEntities(text) {
  var textArea = document.createElement("textarea");
  textArea.innerHTML = text;
  return textArea.value;
}
async function getCartData() {
          try {
              let response = await fetch("/cart.js");
              let cartData_json = await response.json();
              console.log("cartData_json--", cartData_json.item_count);
              $('.cart_drawer-items-qty').empty();
              $('.cart_drawer-items-qty').text(`(${cartData_json.item_count} items)`)
          } catch (error) {
              console.error("Error fetching cart data:", error);
          }
      }
function cartSlick(){
  try {
   if (!$('.upsell-product-main').hasClass('slick-initialized')) { 
    $('.upsell-product-main').slick({
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  dots: true,
                  arrows: false
                });
   }
  } catch (error) {
    console.log(error)
  }
    }
$(document).ready(function () {
  
   // $("input[type='radio'][data-option-id]").on("change", function() {
   //    if ($(this).is(":checked")) {
   //      const selectedId = $(this).data("option-id");
   //      console.log("Selected Option ID:", selectedId);
   //    }
   //  });
  
  $(window).on('scroll', function() {
        $(".header__inline-menu header-menu details").hover(
    function (e) {
      e.preventDefault();

      $(this).attr("open", true);
      $(this).find("summary").attr("aria-expanded", true);
    },
    function () {
      $(this).removeAttr("open");
      $(this).find("summary").removeAttr("aria-expanded");
    }
  );
});

  setTimeout(()=>{
    cartSlick();
  }, 500);
  getCartData();

  $(".annouce-slide").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    pauseOnHover: true,
    cssEase: "linear",
    arrows: false,
    rtl: false,
    infinite: true, // Allows infinite loop
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
});

  $('.firstcollection .collection-list').slick({
    slidesToShow: 5,
    slidesToScroll: 3,
    // speed: 20000,
    arrows: true,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        },
      },
    ],
  });
  $('.na-collection').slick({
    slidesToShow: 4,
    slidesToScroll: 2,
    // speed: 20000,
    arrows: true,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
         
        },
      },
    ],
  });
  $('.upsell-product-main').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false
    });
  if($(window).width() < 768){
    $('.mosaic__inner').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      // speed: 20000,
      arrows: false,
      dots: false,
      infinite: false,
      // adaptiveHeight: true
    });
    $('.testimonie-inner').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      // speed: 20000,
      arrows: false,
      dots: true,
      infinite: false,
      
    });
    $('.footer-block--menu .footer-block__heading').removeClass('link-show')
    $('.footer-block--menu .footer-block__heading').click(function () {
        $(this).toggleClass('link-show');
    });
  }
    $(document).on('click', '.quick-add__submit ', function () {
      setTimeout(()=>{
          $('.quick-add-modal__content-info .product__media-list ').slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true,
          });
        var $modalContent = $('.quick-add-modal[open] .product__info-wrapper');
        if ($modalContent.length) {
            $modalContent.find('.product__text, .product__title, .no-js-hidden .price ')
                .wrapAll('<div class="ctp-content"></div>');
        
            var ctp = $modalContent.find('.ctp-content').detach();
            $modalContent.closest('.product ').find('.grid__item').before(ctp);
            $modalContent.closest('.product ').find('.grid__item + .ctp-content').hide();
             $modalContent.closest('.product ').find('.grid__item .slick-slide .ctp-content').hide();
        }
      },2000);
      
    });
  
  $('.gallery_slider').slick({
    slidesToShow: 5,
    slidesToScroll: 4,
    arrows: true,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
          infinite: false,
          // centerMode:true
        },
      },
    ],
  });

  $('.text-slider-inner').slick({
    arrows: false,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 7000,
    cssEase: "linear",
    pauseOnHover: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $('.prod--slide-innr').slick({
    arrows: false,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 7000,
    cssEase: "linear",
    pauseOnHover: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
       {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $(document).on('click', '.reelUp_product_zoom_svg_wrapper', function () {
      $('#image_zoomed_model').show();
        $('.image-zoomed-model').addClass('image-zoom-show');
        $(this).closest('.pdp-detail-imgs').addClass('zoom-img-active')
      var zoom_src = $(this).closest('.pdp-detail-imgs').find('.pdp-detail-img img').attr('src');
      console.log(zoom_src);
    $('.image-zoomed-model').find('.images-zoom-imner img').attr('src', zoom_src);
     $('.image-zoomed-model').find('.images-zoom-imner').css('background-image', `url(${zoom_src})`);
    var numbers = $(this).parents('.pdp-media-cont').find('.slick-track').children().length;
    console.log(numbers);
    $('.images-zoom-dots').empty();
    for (var i = 1; i <= numbers; i++) {
        $('.images-zoom-dots').append('<span>' + i + '</span>');
    }
    const parentContainer = $(this).closest('.pdp-media-cont');
    const slides = parentContainer.find('.slick-track .slick-slide').toArray();
    slides.forEach((slide, index) => {
        if ($(slide).find('.zoom-img-active').length > 0) {
            console.log('Active Index: ', index); 
      $('.images-zoom-dots span').removeClass('dots-active');
    $('.images-zoom-dots span').eq(index).addClass('dots-active');
        } 
    });


    
  });
    $('.images-zoom-imner img').hover(function () {
            // When mouse enters the image
            $(this).parent('.images-zoom-imner').addClass('zoom_showing');
        }, function () {
            // When mouse leaves the image
            $(this).parent('.images-zoom-imner').removeClass('zoom_showing');
        });
  const left = document.querySelector(".images-zoom-imner");
    
    left.addEventListener("mousemove", handleMousemove, false);
    
    function handleMousemove(event) {
        let { width, height } = left.getBoundingClientRect();
        let xAxis = (event.offsetX / width) * 100;
        let yAxis = (event.offsetY / height) * 100;
    
        // Increase the zoom level
        left.style.backgroundSize = '300%'; // Set the zoom level (adjust as needed)
        
        // Adjust the background position based on mouse movement
        left.style.backgroundPosition = `${xAxis}% ${yAxis}%`;
    }

  $(document).on('click', '.close--btn', function () {
      $('#image_zoomed_model').hide();
        $('.image-zoomed-model').removeClass('image-zoom-show');
    $('.images-zoom-dots span').removeClass('dots-active');
  });
  
  $(document).on("click", ".next--img", function () {
    var $el = $(this),
      $wrap = $el.closest(".gallery--section"),
      $nextimg = $wrap.find(".zoom-img-active").closest('.slick-slide').next();
        console.log($nextimg);
    if ($nextimg.length > 0) {
      $wrap.find(".zoom-img-active").removeClass("zoom-img-active");
      $nextimg.addClass("zoom-img-active");
       var $nextSrc = $nextimg.find('.pdp-detail-imgs .pdp-detail-img img').attr('src');
        console.log($nextSrc);
      $('.image-zoomed-model').find('.images-zoom-imner img').attr('src', $nextSrc);
       $('.image-zoomed-model').find('.images-zoom-imner').css('background-image', `url(${$nextSrc})`);
      const parentContainer = $wrap.find(".zoom-img-active").closest('.slick-slide');
        const slides = parentContainer.closest('.slick-track').find('.slick-slide');
        const nextIndex = slides.index($nextimg);
        console.log(nextIndex)
        // Update dots
        $('.images-zoom-dots span').removeClass('dots-active'); // Clear all active dots
        $('.images-zoom-dots span').eq(nextIndex).addClass('dots-active');
    }
  });
  $(document).on("click", ".prev--img", function () {
    var $el = $(this),
      $wrap = $el.closest(".gallery--section"),
      $nextimg = $wrap.find(".zoom-img-active").closest('.slick-slide').prev();
        console.log($nextimg);
    if ($nextimg.length > 0) {
      $wrap.find(".zoom-img-active").removeClass("zoom-img-active");
      $nextimg.addClass("zoom-img-active");
       var $nextSrc = $nextimg.find('.pdp-detail-imgs .pdp-detail-img img').attr('src');
        console.log($nextSrc);
      $('.image-zoomed-model').find('.images-zoom-imner img').attr('src', $nextSrc);
      const parentContainer = $wrap.find(".zoom-img-active").closest('.slick-slide');
        const slides = parentContainer.closest('.slick-track').find('.slick-slide');
        const nextIndex = slides.index($nextimg);
        console.log(nextIndex)
        // Update dots
        $('.images-zoom-dots span').removeClass('dots-active'); // Clear all active dots
        $('.images-zoom-dots span').eq(nextIndex).addClass('dots-active');
    }
  });
  $(document).on("click", ".gallery_block__js video", function () {
    var $video = $(this),
      $el = $video.closest(".gallery_block__js"),
      info = JSON.parse($el.attr("data-info")),
      v_i_htm = $el.find(".capture_gallery_item").html(),
      pdp_htm = $el.find(".video-product-dtails").html(),
      slide_loader = $(pdp_htm).find('.pdp-media-cont'),
      decodedDescription = decodeHTMLEntities(info.description),
      content = `<div class="v_i_main_wrapper">
                  <div class="v_i_wrapper">
                    <!-- <button class="btn_prev_mdl vimdl_arrow">Prev</button>-->
                    <div class="vi_mdl__box">
                      <div class="vi_mdl_item vi_mdl_left">
                        ${v_i_htm}
                      </div>
                      <div class="vi_mdl_item vi_mdl_right">
                        ${pdp_htm}
                        
                        
                      </div>
                    </div>
                    <!-- <button class="btn_next_mdl vimdl_arrow">Next</button>-->
                  </div>
                </div>`;

    console.log(info, "<<info");
    $(".zm__content__js").html(content);
    $(".zm__content__js .inplab").each(function() {
      var t = $(this).find('input').attr('id');
       $(this).find('input').attr('id', `modalll_${t}`)
      $(this).find('label').attr('for' ,`modalll_${t}`)
    });
    $("#zoomed__modal").show();
    $el.addClass("div-avtive");
     initSlick();
  });
  $(document).on("click", "#zoomed__modal_close", function () {
      $("#zoomed__modal").hide();
       unslickSlick();
    });

  $(window).on("click", function (e) {
    if (e.target.id === "quick_veiw__modal") {
      qv_modal(false);
    }
    if (e.target.id === "zoomed__modal") {
      $("#zoomed__modal").hide();
      unslickSlick();
    }
  });
  $(document).on("click", ".btn_prev_mdl", function () {
    var $el = $(this),
      $wrap = $el.closest(".gallery--section"),
      $nextDiv = $wrap.find(".div-avtive").closest('.slick-slide').prev();
        // console.log($nextDiv);
    unslickSlick();
    if ($nextDiv.length > 0) {
      $wrap.find(".div-avtive").removeClass("div-avtive");
      $nextDiv.addClass("div-avtive");
        $nextDiv.find('video').click();
      
    }
  });
  $(document).on("click", ".btn_next_mdl", function () {
    var $el = $(this),
      $wrap = $el.closest(".gallery--section"),
      $nextDiv = $wrap.find(".div-avtive").closest('.slick-slide').next();
        // console.log($nextDiv);
    unslickSlick();
    if ($nextDiv.length > 0) {
      $wrap.find(".div-avtive").removeClass("div-avtive");
      $nextDiv.addClass("div-avtive");
        $nextDiv.find('video').click();
      
    }
  });
  $(".list-mute-button").on("click", function () {
    var button = $(this),
      video = button.closest(".video_item").find("video").get(0),
      isMuted = video.muted;
    video.muted = !isMuted;

    if (video.muted) {
      button.find(".mute-icon").show();
      button.find(".unmute-icon").hide();
    } else {
      button.find(".mute-icon").hide();
      button.find(".unmute-icon").show();
    }
  });

  if ($('.vc-imges-wrap .vc-slide').length > 0) {
    $('.vc-imges-wrap .vc-slide').each(function (index) {
        var cont_id = $(this).attr('id'); // Get the id of the current slide
        $('.vc-dots .sticky-images-and-text__dots-inner').append(`
            <a href="#${cont_id}">
                <button type="button">${index + 1}</button>
            </a>
        `);
    });
}
const isMobile = window.matchMedia("(max-width: 768px)").matches;

if (isMobile) {
let lastScrollY = 0;

  $(window).on('scroll', function () {
      const currentScrollY = $(this).scrollTop();
      $('.vc-imges-wrap').scrollLeft($('.vc-imges-wrap').scrollLeft() + (currentScrollY - lastScrollY));
      lastScrollY = currentScrollY;
  
      updateMostVisibleSlide();
  });

  function updateMostVisibleSlide() {
      let mostVisibleSlide = null;
      let maxVisibleArea = 0;
  
      $('.vc-slide').each(function () {
          const slideRect = $(this)[0].getBoundingClientRect();
          const viewportRect = $('.vc-imges-wrap')[0].getBoundingClientRect();
  
          const visibleArea = Math.max(0, Math.min(slideRect.right, viewportRect.right) - Math.max(slideRect.left, viewportRect.left));
  
          if (visibleArea > maxVisibleArea) {
              maxVisibleArea = visibleArea;
              mostVisibleSlide = $(this);
          }
      });
  
       $('.vc-slide').removeClass('is-active');
        $('.vc-content-wrap').removeClass('is-active');
         $('.vc-dots button').removeClass('is-active');
      if (mostVisibleSlide) {
          mostVisibleSlide.addClass('is-active');
           const index = $('.vc-slide').index(mostVisibleSlide);
          $('.vc-content-wrap').eq(index).addClass('is-active');
          $('.vc-dots button').eq(index).addClass('is-active');
      }
  }
} else{
    $(window).on('scroll', function () {
      let mostVisible = null;
      let maxVisibleArea = 0;
  
      $('.vc-slide').each(function () {
          const elementTop = $(this).offset().top;
          const elementBottom = elementTop + $(this).outerHeight();
          const viewportTop = $(window).scrollTop();
          const viewportBottom = viewportTop + $(window).height();
          const visibleTop = Math.max(elementTop, viewportTop);
          const visibleBottom = Math.min(elementBottom, viewportBottom);
          const visibleArea = Math.max(0, visibleBottom - visibleTop);
  
          if (visibleArea > maxVisibleArea) {
              maxVisibleArea = visibleArea;
              mostVisible = $(this);
          }
      });
      
     
      $('.vc-slide').removeClass('is-active');
      $('.vc-content-wrap').removeClass('is-active');
       $('.vc-dots button').removeClass('is-active');
  
      if (mostVisible) {
          mostVisible.addClass('is-active');
  
          const index = $('.vc-slide').index(mostVisible);
  
          $('.vc-content-wrap').eq(index).addClass('is-active');
          $('.vc-dots button').eq(index).addClass('is-active');
      }
  });
}

window.onVariantChange = (variant) => {
  $(document).on('change', '.varient-opt variant-radios input', function () {
    $('.variant--id input').val(variant.id);
    $(this).prop('checked', true);
  })
  console.log(variant.id,"<<<")
}
  $(document).on('click', '.buy-btn .add-to-cart', function () {
    var varientID = $(this).parents('.card_information-reel').find('.variant--id input').val();
    console.log(varientID,'varientID');
    var formData = {
                      id: varientID,
                      qty: 1
                    };
     $.ajax({
            type: "POST",
            url: "/cart/add.js",
            cache: false,
            data: formData,
            dataType: "json",
            success: function (responsse) {
              console.log(responsse);
              $('cart-drawer').addClass('active');
              $("cart-drawer").removeClass('is-empty');
              $(".drawer__inner-empty").hide();
              $("cart-drawer").load(location.href + " #CartDrawer");
              $("#cart-icon-bubble").load(location.href + " #cart-icon-bubble");
              // window.location.href = "/cart";
              
              $('.cart-addded').empty();
              $('.cart-addded').text('Product added');
              setTimeout(()=>{
                $('.cart-addded').empty();
                cartSlick();
              }, 2000)
              
            },
            error: function (xhr, ajaxOption, error) {
              console.error("Error adding product to cart:", error);
            },
          });
  });
  
    
  
  $(".header__inline-menu header-menu details").hover(
    // function (e) {
    //   e.preventDefault();

    //   $(this).attr("open", true);
    //   $(this).find("summary").attr("aria-expanded", true);
    // },
    // function () {
    //   $(this).removeAttr("open");
    //   $(this).find("summary").removeAttr("aria-expanded");
    // }
  );

});
$(document).on(
    "keyup input",
    ".search-modal__form .search__input",
    function () {
      var inputVal = $(this).val().trim();
      if (inputVal.length > 0) {
        $(".search_bar--wrapper").hide();
      } else {
        $(".search_bar--wrapper").show();
      }
    }
  );
  $(".search-modal__close-button, .reset__button").on("click", function () {
    $(".search_bar--wrapper").show();
  });
  $(document).on("input", ".search-modal__form", function () {
    $(".search_bar--wrapper").hide();
  });

function initSlick() {
    var $slider = $('.pdp-media-cont');
    if ($slider.length && $slider.children().length) {
        console.log('Initializing Slick...');
        $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false
        });
    } else {
        console.error('Slider element not found or has no slides.');
    }
}

function unslickSlick() {
  var $slider = $('.pdp-media-cont');
    if ($slider.hasClass('slick-initialized')) {
        console.log('Unslicking...');
        $slider.slick('unslick');
    }
}
let lastScrollTop = 0;

window.addEventListener('scroll', () => {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const imagesOne = document.querySelector('.images-one');
  const imagesTwo = document.querySelector('.images-two');

  // Determine the scroll direction
  if (scrollTop > lastScrollTop) {
    // Scrolling down: set images apart
    imagesOne.style.transform = 'translateX(-6.9333%)'; // Move left
    imagesTwo.style.transform = 'translateX(6.9333%)';  // Move right
  } else {
    // Scrolling up: set images closer
    imagesOne.style.transform = 'translateX(1.9667%)'; // Move right
    imagesTwo.style.transform = 'translateX(-1.9667%)'; // Move left
  }

  lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
});
$(document).on('click', '.drwer-close-wrap', function(){
    $('header-drawer .header__icon ').click();
})
$(document).on('click', '.quick-add-modal__toggle .icon-close', function () {
    $(this).closest('.quick-add-modal').removeAttr('open');
});
$(document).on('click', '.quick-add-modal .product-form__submit', function () {
    $(this).closest('.quick-add-modal').removeAttr('open');
});